import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Masthead, { MastheadLink, MastheadTitle } from "@amzn/meridian/masthead";
import logo from "src/images/logo.svg";
import {
  CPT_AUDITOR_LDAP_GROUP,
  VLM_AUDITOR_LDAP_GROUP,
  VLM_BETA_TESTER_ALIASES,
} from "src/constants";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { linkClickHandler } from "src/helpers";
import Menu, { MenuItem } from "@amzn/meridian/menu";
import Button from "@amzn/meridian/button";
import helpToken from "@amzn/meridian-tokens/base/icon/help";
import Icon from "@amzn/meridian/icon";
import downloadLargeTokens from "@amzn/meridian-tokens/base/icon/download-large";
import { isAdminUser } from "src/utils/permissionUtil";
import { loginAsGeneralUser } from "src/store/userSlice";
import { resetListViewPage } from "src/store/auditSlice";
import { getBatchJobs } from "src/store/batchExtractionSlice";
import AutomatedJobsService from "src/services/automatedJobsService";
import { getAutomatedJobs } from "src/store/automatedBatchJobSlice";

const header = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const location = useLocation();

  const { ldap, alias } = useAppSelector((state) => state.user);

  const canSeeVlmAudit =
    ldap.includes(VLM_AUDITOR_LDAP_GROUP) || VLM_BETA_TESTER_ALIASES.includes(alias);

  const buttonRef = useRef();
  const [open, setOpen] = useState(false);
  const { automatedJobs } = useAppSelector((state) => state.automatedBatchJobSlice);
  const onClickButton = () => setOpen(true);
  const onClose = () => setOpen(false);
  useEffect(() => {
    dispatch(getAutomatedJobs());
  }, []);

  return (
    <Masthead>
      <MastheadTitle>
        <img src={logo} onClick={() => navigate("/")} width="400" height="60" />
      </MastheadTitle>
      <MastheadLink
        onClick={() => navigate("/dataExtraction")}
        selected={location.pathname.includes("/dataExtraction")}
        data-cy={"data-extraction__tab"}
      >
        Data Extraction
      </MastheadLink>
      <MastheadLink
        onClick={() => navigate("/modelManagement")}
        selected={location.pathname.includes("/modelManagement")}
        data-cy={"model-detail-management__tab"}
      >
        Model Detail Management
      </MastheadLink>
      <MastheadLink
        onClick={() => navigate("/batchProcess")}
        selected={location.pathname.includes("batchProcess")}
        data-cy={"batch-process__tab"}
      >
        Batch process
      </MastheadLink>
      <MastheadLink
        onClick={() => navigate("/validationWorkflow")}
        selected={location.pathname.includes("validationWorkflow")}
        data-cy={"validation-workflow__tab"}
      >
        Validation Workflow
      </MastheadLink>
      {ldap.includes(CPT_AUDITOR_LDAP_GROUP) && (
        <MastheadLink
          onClick={() => navigate("/audit")}
          selected={location.pathname.includes("/audit")}
          data-cy={"audit-workflow__tab"}
        >
          Audit Workflow
        </MastheadLink>
      )}
      {canSeeVlmAudit && (
        <MastheadLink
          onClick={() => navigate("/vlmAudit")}
          selected={location.pathname.includes("/vlmAudit")}
          data-cy={"vlm-audit-workflow__tab"}
        >
          VLM Audit Workflow
        </MastheadLink>
      )}
      {automatedJobs.length > 0 && (
        <MastheadLink
          onClick={() => navigate("/automatedJobs")}
          selected={location.pathname.includes("/automatedJobs")}
          data-cy={"automated-batch-job__tab"}
        >
          Automated Batch Job
        </MastheadLink>
      )}
      <Button
        ref={buttonRef}
        onClick={onClickButton}
        aria-haspopup="menu"
        aria-expanded="false"
        type={"link"}
      >
        Help & Support
        <Icon tokens={helpToken}></Icon>
      </Button>
      <Menu
        anchorNode={buttonRef.current}
        id="my-menu"
        open={open}
        position="bottom"
        onClose={onClose}
        alignment="start"
      >
        <MenuItem
          onClick={() => {
            linkClickHandler(
              "https://taskei.amazon.dev/tasks/create?template=279ae8b7-58c2-418c-b160-041ffb996caf",
            );
          }}
        >
          Use case onboard
        </MenuItem>
        <MenuItem
          onClick={() => {
            linkClickHandler(
              "https://taskei.amazon.dev/tasks/create?template=32cabab1-1b5a-4b6d-8c83-6a46b888dfd1",
            );
          }}
        >
          Feature Request
        </MenuItem>
        <MenuItem
          onClick={() => {
            linkClickHandler("https://amazon.enterprise.slack.com/archives/C077E6TGH32");
          }}
        >
          User slack channel / Report issues
        </MenuItem>
        <MenuItem
          onClick={() => {
            linkClickHandler("https://w.amazon.com/bin/view/GHT/Excavator/");
          }}
        >
          Excavator Wiki
        </MenuItem>
        {isAdminUser(ldap) && (
          <MenuItem
            onClick={() => {
              dispatch(loginAsGeneralUser());
            }}
          >
            Login as General User
          </MenuItem>
        )}
      </Menu>
    </Masthead>
  );
};
export default header;
